export class ContractTemplateDeleteEvent {
  pkId: number;
  noOfCustomersAssigned: number;
  executor: {
    resolve: () => void;
    reject: () => void;
  };

  constructor(pkId: number, customersCount: number, resolveFn: () => void, rejectFn: () => void) {
    this.pkId = pkId;
    this.noOfCustomersAssigned = customersCount;
    this.executor = {
      resolve: resolveFn,
      reject: rejectFn
    };
  }
}
